export const palette = {
  white: '#ffffff',
  black: '#000000',
  blue: {
    950: '#162456',
    900: '#1C398E',
    800: '#17359E',
    700: '#1447E6',
    600: '#1056F0',
    500: '#277CFE',
    400: '#51A2FF',
    300: '#8EC5FF',
    200: '#BEDBFF',
    100: '#DBEAFE',
    50: '#EFF6FF'
  },
  sky: {
    950: '#052F4A',
    900: '#024A70',
    800: '#00598A',
    700: '#0069A8',
    600: '#0084D1',
    500: '#00A6F4',
    400: '#00BCFF',
    300: '#74D4FF',
    200: '#B8E6FE',
    100: '#DFF2FE',
    50: '#F0F9FF'
  },
  gray: {
    950: '#09090B',
    900: '#18181B',
    800: '#2F2F2F',
    700: '#4B4B4B',
    600: '#5B5B5B',
    500: '#787878',
    400: '#A6A6A7',
    300: '#D4D4D8',
    200: '#E4E4E7',
    100: '#F4F4F5',
    50: '#FAFAFA'
  },
  red: '#F01000',
  // green: '#4caf50',
  // yellow: '#ffeb3b',
  transparent: 'transparent'
};

export type paletteType = typeof palette;
